import axios from "axios";
import { authHeader } from "./authHeader";


class AxiosInstance {
  constructor(baseUrl, instanceId) {
    this.baseUrl = baseUrl
    this.instanceId = instanceId
  }

  getAxiosInstance() {
    if (AxiosInstance.instanceMap.has(this.instanceId)) {
      return AxiosInstance.instanceMap.get(this.instanceId)
    } else {
      const axiosInstance = axios.create({
        baseURL: this.baseUrl
      });
      axiosInstance.defaults.headers.accept = "application/json";
      axiosInstance.defaults.headers["Content-Type"] = "application/json";
      axiosInstance.interceptors.request.use(
        (config) => {
          const token = authHeader();
          const auth = token ? token.Authorization : '';
          config.headers['Authorization'] = auth;
          return config;
        },
        (error) => Promise.reject(error),
      );
      AxiosInstance.instanceMap.set(this.instanceId, axiosInstance)
      return axiosInstance;
    }
  }
}
AxiosInstance.instanceMap = new Map();
export {AxiosInstance}